const environments = {
  local: 'development',
  develop: 'develop',
  production: 'production',
  staging: 'staging',
};

export default {
  isLocal() {
    return process.env.NODE_ENV === environments.local;
  },
  isDev() {
    return process.env.DEPLOY_ENV === environments.develop;
  },
  isProduction() {
    return process.env.DEPLOY_ENV === environments.production;
  },
  isStaging() {
    return process.env.DEPLOY_ENV === environments.staging;
  },
};
